/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextBookAuditStatusStatQueryForm model module.
   * @module textbook/model/TextBookAuditStatusStatQueryForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookAuditStatusStatQueryForm</code>.
   * @alias module:textbook/model/TextBookAuditStatusStatQueryForm
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>TextBookAuditStatusStatQueryForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookAuditStatusStatQueryForm} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookAuditStatusStatQueryForm} The populated <code>TextBookAuditStatusStatQueryForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompanyId')) {
        obj['producerCompanyId'] = ApiClient.convertToType(data['producerCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompanyId')) {
        obj['publisherCompanyId'] = ApiClient.convertToType(data['publisherCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 作者 查询chiefEditor｜ deputyEditor ｜contributingAuthors
   * @member {String} author
   */
  exports.prototype['author'] = undefined;
  /**
   * 制作单位id
   * @member {Integer} producerCompanyId
   */
  exports.prototype['producerCompanyId'] = undefined;
  /**
   * 出版社id
   * @member {Integer} publisherCompanyId
   */
  exports.prototype['publisherCompanyId'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;



  export default exports;
;


